const characterTool = {};

characterTool.charConvertTable = {
	ā: 'a',
	Ā: 'A',
	ḍ: 'd',
	ḥ: 'h',
	ī: 'i',
	ṣ: 's',
	ū: 'u',
	ẓ: 'z',
	ṭ: 't',
	Ḥ: 'H',
	ʿ: '‘',
};

characterTool.charConvTableRev = {
	a: 'ā',
	A: 'Ā',
	d: 'ḍ',
	h: 'ḥ',
	i: 'ī',
	s: 'ṣ',
	u: 'ū',
	z: 'ẓ',
	t: 'ṭ',
	H: 'Ḥ',
	'‘': 'ʿ',
};

characterTool.charRegEx = {
	a: '[āa]',
	ā: '[āa]',
	A: '[ĀA]',
	Ā: '[ĀA]',
	d: '[ḍd]',
	ḍ: '[ḍd]',
	h: '[ḥh]',
	ḥ: '[ḥh]',
	i: '[īi]',
	ī: '[īi]',
	s: '[ṣs]',
	ṣ: '[ṣs]',
	u: '[ūu]',
	ū: '[ūu]',
	z: '[ẓz]',
	ẓ: '[ẓz]',
	t: '[ṭt]',
	ṭ: '[ṭt]',
	H: '[ḤH]',
	Ḥ: '[ḤH]',
	'‘': '[ʿ‘]',
	ʿ: '[ʿ‘]',
};

export default characterTool;
